import SimpleAssessment from '@/components/SimpleAssessment';

const Index = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)' }}>
      <SimpleAssessment />
    </div>
  );
};

export default Index;
